import { render } from "./FeaturesTest.vue?vue&type=template&id=6da3cdd2&scoped=true"
import script from "./FeaturesTest.vue?vue&type=script&lang=js"
export * from "./FeaturesTest.vue?vue&type=script&lang=js"

import "./FeaturesTest.vue?vue&type=style&index=0&id=6da3cdd2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da3cdd2"]])

export default __exports__